let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lP4yo")).then(() => parcelRequire('fC4Gj'));